module.exports = __webpack_public_path__ + "static/media/x.720e74ab.png";